/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pink_Frail_Baboon_RoarInputs */

const fr_pink_frail_baboon_roar = /** @type {(inputs: Pink_Frail_Baboon_RoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 Rue Edouard Belin, Olonne-sur-mer`)
};

/**

* @param {Pink_Frail_Baboon_RoarInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const pink_frail_baboon_roar = /** @type {((inputs?: Pink_Frail_Baboon_RoarInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pink_Frail_Baboon_RoarInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_pink_frail_baboon_roar(inputs)
});